export enum CampaignUserType {
    CUSTOMER_SUCCESS = 'customer_success_campaigns',
    MY_CAMPAIGNS = 'my_campaigns',
    CLIENT_CAMPAIGNS = 'client_campaigns',
    SUPPLIER_CAMPAIGNS = 'supplier_campaigns',
}
